export default __webpack_public_path__ + "locales/en/JavascriptSdk.json?hash=95a7a68a0d7b3800e485b7e193354633";